import { useLogout } from "../../hooks/useLogout";

const Logout = () => {
  const { error, logout } = useLogout();
  const handleSubmit = () => {
    logout();
  };
  return (
    <div>
      <button onClick={handleSubmit}>Logout</button>
      {error && <p>{error.message}</p>}
    </div>
  );
};

export default Logout;
